import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Container } from '../../../../../components/web/container/container';
import { WebButton as Button } from '../../../../../components/web/button/web-button';
import { IconNext } from '../../../../../components/app/icons/next';
import { IconApple } from '../../../../../components/app/icons/apple';
import { SignupButton } from '../../../../../components/web/button/signup-button';
import { APP_STORE_URL } from '../../../../../config/app-store';
import { MobileHeroBackdrop } from '../../../../../components/web/subpage-hero/mobile-hero-backdrop';
import { HomepageBrowserPreview } from './homepage-browser-preview';

export const IntroHomepageMarketing: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            data-homepage-hero-content
            className="relative isolate pb-[5rem] pt-[4.8rem] text-brand-secondary lg:pb-[8rem] vl:pt-[7rem]"
        >
            <MobileHeroBackdrop />
            <Container>
                <div className="relative z-[1] grid items-center gap-[5rem] vl:grid-cols-[minmax(0,42rem)_minmax(0,1fr)] vl:gap-[4rem] xl:grid-cols-[minmax(0,50rem)_minmax(0,1fr)] xl:gap-[6rem]">
                    <div className="max-w-[50rem]">
                        <h1 className="font-serif text-[4.4rem] leading-[1.04] tracking-[-0.045em] text-brand-secondary sm:text-[5rem] xl:text-[6.4rem]">
                            <Trans i18nKey="pages.homepage.heroMarketing.title" components={{ br: <br /> }} />
                        </h1>
                        <p className="mt-[2.4rem] max-w-[42rem] text-[1.7rem] leading-[1.6] text-web-copy lg:text-[1.9rem]">
                            {t('pages.homepage.heroMarketing.subtitle')}
                        </p>
                        <div className="mt-[3.2rem] flex flex-wrap items-center gap-[1rem] xl:gap-[1.6rem]">
                            <SignupButton variant="secondary" icon={<IconNext />} iconGap="small" size="large">
                                {t('pages.homepage.heroMarketing.getStarted')}
                            </SignupButton>
                            <Button
                                href={APP_STORE_URL}
                                icon={<IconApple />}
                                iconPosition="right"
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="secondary"
                                variation="outlined"
                                tone="neutral"
                                size="large"
                            >
                                {t('pages.homepage.heroMarketing.appStore')}
                            </Button>
                        </div>
                    </div>
                    <HomepageBrowserPreview />
                </div>
            </Container>
        </section>
    );
};
